@if (!iconButton()) {
  <button type="button" mat-flat-button color="primary" (click)="fileInput.click()"><ng-content></ng-content></button>
}
@if (iconButton()) {
  <button type="button" mat-mini-fab color="primary" (click)="fileInput.click()"><mat-icon>file_upload</mat-icon></button>
}
<input hidden type="file" #fileInput multiple (change)="filesLoaded($event)">
